import React from 'react'
import Portal from '../portal'
import { AppContext, getDefaultState } from '../../config/context'
import './index.scss'
import Login from '../login'
import {
    hbsBoolean,
    getImgUrl,
    createNativeForm,
    throttle,
    safeParse,
    clearUserInfoLocally,
    checkCouponStatus,
    getCouponDateStr,
    showDiscountRate,
    sortCouponList,
    checkUserInfoLocally,
    parseQueryString,
    i18n,
    showDiscount,
    isIE
} from '../../common/util'
import { querySeckillStatus, queryAreaInfo } from './service'
import { preOrder as orderByService, getCouponList, receiveCoupon, getExchangeRate, getPriceByArea } from '../service'
import ee, { EVENT_USER_INVALID, EVENT_TIP, EVENT_USER_LOGIN } from '../../common/util/event'
import { ShowHKD } from '../../config'
import BlackList from '../blackList'
import CouponTip from '../couponTip'

class Product extends React.Component {
    constructor() {
        super(...arguments)
        this.state = {
            showLoginModal: false,
            showFloatPanel: false,
            floatIndex: 1,
            inputBuyNum: '1',
            showBlackListTip: false,
            blackListTipContent: '',
            // showCouponList: false,
            showCouponTip: false,
            couponTipType: '',
            couponTipContent: '',
            couponList: [],
            activityType: -1,
            activityId: -1,
            isSeckillActivity: false,
            gid: 0,
            tGoodsId: '',
            showGroupInfo: false,
            showServerInfo: false,
            showGroupSelect: false,
            showServerSelect: false,
            groupList: [],
            serverMap: {},
            serverList: [],
            groupCode: null,
            groupName: '',
            serverCode: null,
            serverName: '',
            hkdRate: 0,
            ...window._inject_app_data_
        }
        if (this.state.showSkus) {
            this.checkSkuValid(this.state.skuValues)
        }
        this.recieveCouponFlag = false
    }

    componentDidMount() {
        ShowHKD && getExchangeRate().then(hkdRate => {
            this.setState({
                hkdRate
            })
        })
        window.addEventListener('scroll', throttle(() => {
            const { top: descTop } = document.getElementById('desc-anchor').getBoundingClientRect()
            if (descTop > 60) {
                return this.setState({ showFloatPanel: false })
            }
            let floatIndex = 1
            const { top: introTop } = document.getElementById('intro-anchor').getBoundingClientRect()
            if (introTop <= 60) {
                floatIndex = 2
                const { top: qaTop } = document.getElementById('qa-anchor').getBoundingClientRect()
                if (qaTop <= 60) {
                    floatIndex = 4
                } else {
                    const sc = document.getElementById('sysconfig-anchor')
                    if (sc && sc.getBoundingClientRect().top <= 60) {
                        floatIndex = 3
                    }
                }
            }
            this.setState({
                showFloatPanel: true,
                floatIndex
            })
        }, 34))
        document.addEventListener('click', () => {
            this.setState({
                // showCouponList: false,
                showGroupSelect: false,
                showServerSelect: false
            })
        })
        ee.addListener(EVENT_USER_INVALID, () => {
            this.clearLoginInfo()
            this.setState({
                showLoginModal: true
            })
        })
        this.checkActivity()
        this.initArea()
        this.initSkuById()
        this.fixUrl()
    }

    fixUrl = () => {
        const url = `/app/${this.state.goodsId}/${this.state.ename ? this.state.ename.replace(/\s/g, '_') : '_'}`
        const path = location.pathname
        if (path.indexOf('/app/') === 0 && (path !== url && path !== url + '/')) {
            try {
                history.replaceState(null, '', `${url}/${location.search}`)
            } catch (e) { }
        }
    }

    goToAnchor = anchor => {
        const top = document.getElementById(anchor).offsetTop + 100 - 60
        if (isIE()) {
            window.scrollTo(0, top)
        } else {
            window.scrollTo({
                top,
                behavior: 'smooth'
            })
        }
    }

    clearLoginInfo = () => {
        clearUserInfoLocally()
        this.context.updateUserInfo(getDefaultState())
    }

    initCoupon = auth => {
        return getCouponList({ pageSize: 99, goodsId: this.state.goodsId }, auth)
            .then(({ entities }) => this.setState({ couponList: sortCouponList(entities.map(e => checkCouponStatus(e, true))) }))
            .catch(e => {
                if (auth && e.code === 401) {
                    this.initCoupon(false)
                    this.clearLoginInfo()
                }
            })
    }

    checkSkuValid = (skuValues) => {
        const skus = this.state.skus
        const newShowSkus = this.state.showSkus.slice(0)
        for (let i = 0; i < newShowSkus.length; ++i) {
            const list = newShowSkus[i].list.slice(0)
            const v = skuValues[i]
            for (let j = 0; j < list.length; ++j) {
                if (list[j].name === v) {
                    list[j].isActive = true
                    list[j].valid = true
                    continue
                }
                const newValues = skuValues.slice(0)
                newValues[i] = list[j].name
                list[j].isActive = false
                list[j].valid = !!skus.find(s => s.name === newValues.join('/'))
            }
            newShowSkus[i].list = list
        }
        this.setState({
            showSkus: newShowSkus
        })
    }

    closeLoginModal = () => {
        this.setState({
            showLoginModal: false
        })
    }

    checkActivity = () => {
        const { activityType, activityId } = this.state
        if (activityType > -1 && activityId > -1) {
            return
        }
        const seacba = parseQueryString(location.search).seacba
        if (!seacba) {
            return this.initCouponActivity()
        }
        const pa = seacba.split('-')
        if (pa.length !== 3) {
            return this.initCouponActivity()
        }
        querySeckillStatus(this.state.goodsId, pa[0], pa[1]).then(({ activityType, activityId, skuIds }) => {
            const skus = this.state.skus.slice(0)
            const currentSkuId = this.state.skuId
            const newState = {
                activityType,
                activityId,
                skus,
                isSeckillActivity: true,
                price: this.state.price
            }
            for (let i = 0; i < skus.length; ++i) {
                let sku = skuIds.find(s => s.skuId === skus[i].skuId)
                if (sku) {
                    skus[i] = {
                        ...skus[i],
                        salePrice: sku.priceAfterDiscount
                    }
                    sku.skuId === currentSkuId && (newState.price = sku.priceAfterDiscount)
                }
            }
            this.setState(newState)
        }).catch(() => {
            this.initCouponActivity()
        })
    }

    initArea = () => {
        queryAreaInfo(this.state.goodsId).then(({ regionList, gameInfo }) => {
            if (gameInfo && Array.isArray(regionList) && regionList.length) {
                const newState = {
                    showGroupInfo: true,
                    showServerInfo: Array.isArray(regionList[0].serverList) && regionList[0].serverList.length > 0,
                    gid: gameInfo.gid
                }
                const groupList = []
                const serverMap = {}
                for (let i = 0; i < regionList.length; ++i) {
                    let { code, name, serverList } = regionList[i]
                    groupList.push({ code, name })
                    newState.showServerInfo && (serverMap[code] = serverList)
                }
                newState.groupList = groupList
                newState.serverMap = serverMap
                this.setState(newState)
            }
        }).catch(() => { })
    }

    getFinalPriceByArea = (skuId, serverCode) => {
        const { gid } = this.state
        gid && getPriceByArea(skuId, gid, serverCode).then(({ totalPrice: price, goods_id: tGoodsId }) => {
            this.setState({
                price,
                tGoodsId
            })
        })
    }

    initCouponActivity = () => {
        ee.addListener(EVENT_USER_LOGIN, () => {
            this.initCoupon(true)
        })
        this.initCoupon(!!checkUserInfoLocally())
    }

    initSkuById = () => {
        if (!this.state.showSkus || !location.search) {
            return
        }
        const specId = parseQueryString(location.search).spec
        if (!specId || specId === this.state.skuId + '') {
            return
        }
        const sku = this.state.skus.find(s => s.skuId + '' === specId)
        if (sku) {
            const { skuId, salePrice: price, primePrice: originalPrice, stockNum: saleNum, name } = sku
            const skuValues = name.split('/')
            this.setState({
                skuId,
                price,
                originalPrice,
                saleNum,
                skuValues
            })
            this.checkSkuValid(skuValues)
        }
    }

    chooseSkuOrRel = (k, i) => {
        if (k.isActive || !k.valid) {
            return
        }
        const skuValues = this.state.skuValues.slice(0)
        skuValues[i] = k.name
        const sku = this.state.skus.find(s => s.name === skuValues.join('/'))
        if (sku) {
            if (!sku.skuId) {
                return location.href = `/p/${sku.goodsId}.html`
            }
            const { skuId, salePrice: price, primePrice: originalPrice, stockNum: saleNum, soldOut } = sku
            const newState = {
                skuId,
                originalPrice,
                saleNum,
                skuValues,
                soldOut: soldOut === 1
            }
            this.checkSkuValid(skuValues)
            if (this.state.serverCode) {
                this.getFinalPriceByArea(skuId, this.state.serverCode)
            } else {
                newState.price = price
            }
            this.setState(newState)
        }
    }

    inputNum = e => {
        const value = e.target.value
        const originalValue = this.state.inputBuyNum
        if (!value || (/^[1-9]\d*$/.test(value) && Number(value) <= this.state.buyNum)) {
            this.setState({
                inputBuyNum: value
            })
        } else {
            setTimeout(() => {
                this.setState({
                    inputBuyNum: originalValue
                })
            }, 0)
        }
    }

    minusBuyNum = () => {
        this.setState({
            inputBuyNum: Number(this.state.inputBuyNum) - 1 + ''
        })
    }

    addBuyNum = () => {
        const cn = Number(this.state.inputBuyNum) || 1
        this.setState({
            inputBuyNum: cn + 1 + ''
        })
    }

    submit = () => {
        const userInfo = this.context.user
        if (userInfo.isLogin !== 1 || !userInfo.phone) {
            window._imp = true
            return this.setState({
                showLoginModal: true
            })
        }
        const { showGroupInfo, showServerInfo, groupCode, serverCode, groupName, serverName, goodsId, tGoodsId, inputBuyNum } = this.state
        const num = Number(inputBuyNum)
        let serverExt = false
        if (showGroupInfo) {
            if (!groupCode) {
                return ee.emit(EVENT_TIP, '请选择大区', 'warn')
            }
            serverExt = {
                goodsId: tGoodsId,
                region: groupCode,
                groupName,
                buyNum: num
            }
            if (showServerInfo) {
                if (!serverCode) {
                    return ee.emit(EVENT_TIP, '请选择服务器', 'warn')
                }
                serverExt.server = serverCode
                serverExt.serverName = serverName
            }
        }
        const { skuId, activityType, activityId, ename } = this.state
        orderByService(
            skuId,
            num,
            activityType,
            activityId,
            serverExt
        ).then(data => {
            const { payAmount, subOrders, isQq, reductionAmount: discountValue } = data
            subOrders.forEach(so => {
                so.extDesc = safeParse(so.extDesc)
            })
            createNativeForm({
                action: '/order/confirm',
                data: {
                    goodsId,
                    ename,
                    activityType,
                    activityId,
                    discountValue,
                    isQq,
                    payAmount,
                    subOrders: JSON.stringify(subOrders)
                }
            }).submit()
        }).catch(e => {
            if (e.code === 403) {
                this.setState({
                    showBlackListTip: true,
                    blackListTipContent: e.message
                })
            } else if (e.code !== 401) {
                ee.emit(EVENT_TIP, e.message)
            }
        })
    }

    closeBlackListTip = () => {
        this.setState({ showBlackListTip: false })
    }

    // toggleCouponList = e => {
    //     e.stopPropagation()
    //     const { showCouponList } = this.state
    //     this.setState({ showCouponList: !showCouponList })
    // }

    recieveCoupon = coupon => {
        if (coupon.statusClass !== 'normal' || this.recieveCouponFlag) {
            return
        }
        if (this.context.user.isLogin !== 1) {
            return this.setState({
                showLoginModal: true
            })
        }
        this.recieveCouponFlag = true
        receiveCoupon(coupon.id).then(() => {
            this.setState({
                showCouponTip: true,
                couponTipType: 'success'
            })
            this.initCoupon(true)
        }).catch(e => {
            if (e.code === 400) {
                this.setState({
                    showCouponTip: true,
                    couponTipType: 'warning',
                    couponTipContent: e.message || '优惠券已被领完'
                })
                this.initCoupon(true)
            } else if (e.code !== 401) {
                this.setState({
                    showCouponTip: true,
                    couponTipType: 'error'
                })
                ee.emit(EVENT_TIP, e.message)
            }
        }).finally(() => {
            this.recieveCouponFlag = false
        })
    }

    closeCouponTip = () => {
        this.setState({
            showCouponTip: false
        })
    }
    toggleGroupSelect = e => {
        e.stopPropagation()
        this.setState({
            showGroupSelect: !this.state.showGroupSelect,
            showServerSelect: false
        })
    }

    toggleServerSelect = e => {
        e.stopPropagation()
        this.state.serverList.length && this.setState({
            showGroupSelect: false,
            showServerSelect: !this.state.showServerSelect
        })
    }

    chooseGroup = (e, groupCode, groupName) => {
        e.stopPropagation()
        if (groupCode === this.state.groupCode) {
            return this.setState({
                showGroupSelect: false
            })
        }
        const newState = {
            showGroupSelect: false,
            groupCode,
            groupName
        }
        if (this.state.showServerInfo) {
            newState.showServerSelect = true
            newState.serverList = this.state.serverMap[groupCode] || []
            newState.serverCode = null
            newState.serverName = ''
        }
        this.setState(newState)
    }

    chooseServer = (e, serverCode, serverName) => {
        e.stopPropagation()
        this.setState({
            showServerSelect: false,
            serverCode,
            serverName
        })
        this.getFinalPriceByArea(this.state.skuId, serverCode)
    }

    render() {
        const { lang } = this.context.user
        const {
            platformRels,
            showSkus,
            showLimit,
            inputBuyNum,
            buyNum,
            price,
            originalPrice,
            soldOut,
            sellOutTitle,
            buyTitle,
            showLoginModal,
            showFloatPanel,
            floatIndex,
            showSysConfig,
            showGroupInfo,
            showGroupSelect,
            groupList,
            groupName,
            groupCode,
            showServerSelect,
            showServerInfo,
            serverList,
            serverName,
            serverCode,
            couponList,
            // showCouponList,
            showCouponTip,
            couponTipType,
            couponTipContent,
            showBlackListTip,
            blackListTipContent,
            hkdRate,
            isSeckillActivity,
            gamePlatform,
            ename
        } = this.state
        return <div className={isSeckillActivity ? 'product-side-content seckill' : 'product-side-content'}>
            {
                couponList.length > 0 && <div className='product-coupon-container'>
                    <div className='product-coupon-txt'>
                        {i18n('您有', lang)}
                        <span className='highlight'>{couponList.length}</span>
                        {i18n('张优惠券可使用', lang)}
                        <div className={hbsBoolean(ename) ? 'product-coupon-content' : 'product-coupon-content without-ename'}>
                            <ul>
                                {
                                    couponList.map(c => (<li className='product-coupon-item'>
                                        {
                                            c.amountDiscountType === 0
                                                ? <div className='coupon-effect'>&yen;{c.discountsPrice}</div>
                                                : <div className='coupon-effect'>{showDiscountRate(c.discountsPrice)}折</div>
                                        }
                                        <button className={`coupon-action ${c.statusClass}`} onClick={() => this.recieveCoupon(c)}>
                                            {i18n(c.statusClass === 'disabled' ? '已领完' : c.statusClass === 'use' ? '已领取' : '领取', lang)}
                                        </button>
                                        <p className='coupon-name'>{i18n(c.amountLimitation === 0 ? '无门槛' : `满${c.amountLimitation}元可用`, lang)}【{i18n(c.couponName, lang)}】</p>
                                        <p className='coupon-date'>{i18n(getCouponDateStr(c), lang)}</p>
                                    </li>))
                                }
                            </ul>
                        </div>
                    </div>
                </div>
            }
            {
                gamePlatform && <div className="product-checkbox-ul">
                    <label className="product-checkbox-title">{i18n('游戏平台', lang)}</label>
                    {
                        platformRels.map(p => (p.isActive
                            ? <div className="product-checkbox main active"><img alt="" className="product-platform-icon"
                                src={getImgUrl(p.gamePlatformUrl)}></img>{p.gamePlatformName}</div>
                            : <a target="_self" href={`/p/${p.goodsId}.html`}>
                                <div className="product-checkbox main"><img alt="" className="product-platform-icon"
                                    src={getImgUrl(p.gamePlatformUrl)}></img>{p.gamePlatformName}</div>
                            </a>))
                    }
                </div>
            }
            {
                showGroupInfo && <div className='product-checkbox-ul'>
                    <label className="product-checkbox-title">{i18n('区服', lang)}</label>
                    <div className='product-area-select product-checkbox main' onClick={this.toggleGroupSelect}>
                        <i className={showGroupSelect ? 'drop active' : 'drop'}></i>{i18n(groupName || '选择大区', lang)}
                    </div>
                    {
                        showServerInfo && <div className={serverList.length ? 'product-area-select product-checkbox server' : 'product-area-select product-checkbox server disabled'} onClick={this.toggleServerSelect}>
                            <i className={showServerSelect ? 'drop active' : 'drop'}></i>{i18n(serverName || '选择服务器', lang)}
                        </div>
                    }
                    <ul className={showGroupSelect ? 'product-area-slide' : 'product-area-slide hidden'}>
                        {
                            groupList.map(g => (<li key={g.code} className={groupCode === g.code ? 'product-area-item active' : 'product-area-item'} onClick={e => this.chooseGroup(e, g.code, g.name)}>{i18n(g.name, lang)}</li>))
                        }
                    </ul>
                    <ul className={showServerSelect ? 'product-area-slide' : 'product-area-slide hidden'}>
                        {
                            serverList.map(s => (<li key={s.code} className={serverCode === s.code ? 'product-area-item active' : 'product-area-item'} onClick={e => this.chooseServer(e, s.code, s.name)}>{i18n(s.name, lang)}</li>))
                        }
                    </ul>
                </div>
            }
            {
                showSkus && showSkus.map((s, i) => (<div className="product-checkbox-ul">
                    <label className="product-checkbox-title">{i18n(s.name, lang)}</label>
                    {
                        s.list.map(ss => (<div className={ss.isActive ? 'product-checkbox active' : ss.valid ? 'product-checkbox' : 'product-checkbox disabled'} onClick={() => this.chooseSkuOrRel(ss, i)}>
                            {i18n(ss.name, lang)}</div>))
                    }
                </div>))
            }
            {
                showLimit && <div className="product-checkbox-ul num">
                    <label className="product-checkbox-title num">{i18n('购买数量', lang)}</label>
                    {
                        Number(inputBuyNum) > 1
                            ? <div className="product-num-btn" onClick={this.minusBuyNum}>-</div>
                            : <div className="product-num-btn disabled">-</div>
                    }
                    <input type="text" name="g-p-num" className="product-num-input" value={inputBuyNum} onChange={this.inputNum}
                        autocomplete="off"></input>
                    {
                        (!inputBuyNum ? buyNum > 1 : Number(inputBuyNum) < buyNum)
                            ? <div className="product-num-btn" onClick={this.addBuyNum}>+</div>
                            : <div className="product-num-btn disabled">+</div>
                    }
                </div>
            }
            <div className='product-side-bottom'>
                <div className={isSeckillActivity ? 'product-price-wrapper seckill' : 'product-price-wrapper'}>
                    <div className="product-price">&yen;{price}</div>
                    <div className={
                        hbsBoolean(hkdRate)
                            ? hbsBoolean(originalPrice)
                                ? 'product-price-ext with-hkd'
                                : 'product-price-ext only-hkd'
                            : 'product-price-ext'
                    }>
                        {
                            hbsBoolean(hkdRate) && <p className='product-price-hkd'>HK${(hkdRate * price).toFixed(2)}</p>
                        }
                        {
                            hbsBoolean(originalPrice) && <p className="product-price-op">&yen;{originalPrice}</p>
                        }
                    </div>
                    {
                        hbsBoolean(originalPrice) && <div className='product-price-discount'>{showDiscount(price, originalPrice)}</div>
                    }
                </div>
                {
                    soldOut
                        ? <button className="product-submit-btn disabled">{i18n(sellOutTitle, lang)}</button>
                        : <button className="product-submit-btn" onClick={this.submit}>{i18n(buyTitle, lang)}</button>
                }
            </div>
            {
                showLoginModal && <Login close={this.closeLoginModal}></Login>
            }
            {
                showFloatPanel && <div className='product-float-panel'>
                    <ul className='product-float-content'>
                        <li className='product-float-logo-wrapper'>
                            <i className='product-float-logo'></i>
                        </li>
                        <li className={floatIndex === 1 ? 'product-float-index active' : 'product-float-index'} onClick={() => this.goToAnchor('desc-anchor')}>{i18n('简介', lang)}</li>
                        <li className={floatIndex === 2 ? 'product-float-index active' : 'product-float-index'} onClick={() => this.goToAnchor('intro-anchor')}>{i18n('详情', lang)}</li>
                        {
                            showSysConfig && <li className={floatIndex === 3 ? 'product-float-index active' : 'product-float-index'} onClick={() => this.goToAnchor('sysconfig-anchor')}>{i18n('系统需求', lang)}</li>
                        }
                        <li className={floatIndex === 4 ? 'product-float-index active' : 'product-float-index'} onClick={() => this.goToAnchor('qa-anchor')}>{i18n('常见问题', lang)}</li>
                        <li className='product-float-right'>
                            {
                                soldOut
                                    ? <button className="product-float-submit disabled">{i18n(sellOutTitle, lang)}</button>
                                    : <button className="product-float-submit" onClick={this.submit}>{i18n(buyTitle, lang)}</button>
                            }
                        </li>
                    </ul>
                </div>
            }
            {
                showBlackListTip && <BlackList close={this.closeBlackListTip} content={blackListTipContent}></BlackList>
            }
            {
                showCouponTip && <CouponTip type={couponTipType} tip={couponTipContent} close={this.closeCouponTip} dontmove={true}></CouponTip>
            }
        </div>
    }
}

Product.contextType = AppContext
export default Portal(Product, 'G-product-container')